import { render, staticRenderFns } from "./CheckoutApproved.vue?vue&type=template&id=775d4d8c&scoped=true"
import script from "./CheckoutApproved.vue?vue&type=script&lang=js"
export * from "./CheckoutApproved.vue?vue&type=script&lang=js"
import style0 from "./CheckoutApproved.vue?vue&type=style&index=0&id=775d4d8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775d4d8c",
  null
  
)

export default component.exports